/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { getInstallmentName, trackAccount, trackClick, trackImpression, trackPage, } from "./adobe-analytics";
import { Tracklist } from "../meta/Tracklist";
// [UGLY WORKAROUND]
// Page click events are delayed in order to be cancelled by the click on summary
// This is needed because three fiber stopPropagation() doesn't works
var pageClickTimeout = null;
export var metrics = {
    // [ ] checked
    onInitialLoad: function (signedIn, ubisoftId) {
        trackAccount({
            location: "web authentification",
            category: "login",
            action: signedIn ? "signed in" : "signed out",
            ubisoftId: ubisoftId,
            loggedIn: signedIn ? "true" : "false",
            loggedOut: signedIn ? "false" : "true",
        });
    },
    // [ ] checked
    onLogin: function (ubisoftId) {
        trackAccount({
            location: "web authentification",
            category: "login",
            action: "signing in",
            ubisoftId: ubisoftId,
            loggedIn: "true",
            loggedOut: "false",
        });
    },
    // [ ] checked
    onLogout: function () {
        trackAccount({
            location: "web authentification",
            category: "login",
            action: "signing out",
            loggedIn: "false",
            loggedOut: "true",
        });
    },
    // [x] checked
    loginPageDisplayed: function () {
        trackPage({
            pageName: "main",
            pageUrl: window.location.href,
            siteSection: "login",
        });
    },
    // [x] checked
    summaryPageDisplayed: function () {
        trackPage({
            pageName: "main",
            pageUrl: window.location.href,
            siteSection: "summary",
        });
    },
    // [x] checked
    noAccessPageDisplayed: function () {
        trackPage({
            pageName: "no access",
            pageUrl: window.location.href,
            siteSection: "login",
        });
    },
    // [x] checked
    clickOnLogin: function () {
        trackClick({
            location: "page",
            category: "interaction",
            action: "login",
        });
    },
    // [x] checked
    clickOnGetYourEdition: function () {
        trackClick({
            location: "page",
            category: "action",
            action: "get your edition",
        });
    },
    // [x] checked
    clickOnBuyGameHome: function () {
        trackClick({
            location: "page",
            category: "action",
            action: "list of eligible editions",
        });
    },
    // [x] checked
    clickOnContactSupport: function () {
        trackClick({
            location: "page",
            category: "action",
            action: "contact support",
        });
    },
    // [x] checked
    clickOnLogout: function () {
        trackClick({
            location: "page",
            category: "interaction",
            action: "logout",
        });
    },
    // [x] checked
    artbookSummaryDisplayed: function () {
        trackImpression({
            location: "artbook",
            locationDetail: "summary",
            category: "display",
            action: "visible",
        });
    },
    // [x] checked
    artbookPageDisplayed: function (pageIndex) {
        if (pageIndex < 0)
            return;
        trackImpression({
            location: "artbook",
            locationDetail: "page",
            category: "display",
            action: "page ".concat((pageIndex + 1) * 2),
        });
    },
    // [x] checked
    clickOnRightPage: function () {
        pageClickTimeout = setTimeout(function () {
            trackClick({
                location: "artbook",
                locationDetail: "page",
                category: "interaction",
                action: "artbook | next",
            });
        }, 10);
    },
    // [x] checked
    clickOnLeftPage: function () {
        pageClickTimeout = setTimeout(function () {
            trackClick({
                location: "artbook",
                locationDetail: "page",
                category: "interaction",
                action: "artbook | previous",
            });
        }, 10);
    },
    // [x] checked
    clickOnSummaryShortcut: function (pageIndex) {
        if (pageClickTimeout != null) {
            clearTimeout(pageClickTimeout);
        }
        trackClick({
            location: "artbook",
            locationDetail: "summary",
            category: "interaction",
            action: "page ".concat((pageIndex + 1) * 2),
        });
    },
    // [x] checked
    pressOnRightPageKeyboardShortcut: function () {
        trackClick({
            location: "artbook",
            locationDetail: "page",
            category: "interaction",
            action: "keyboard | next",
        });
    },
    // [x] checked
    pressOnLeftPageKeyboardShortcut: function () {
        trackClick({
            location: "artbook",
            locationDetail: "page",
            category: "interaction",
            action: "keyboard | previous",
        });
    },
    // [x] checked
    clickOnNavigationSummary: function () {
        trackClick({
            location: "control bar",
            locationDetail: "navigation bar",
            category: "interaction",
            action: "summary",
        });
    },
    // [x] checked
    clickOnNavigationRightArrow: function () {
        trackClick({
            location: "control bar",
            locationDetail: "navigation bar",
            category: "interaction",
            action: "control bar | next",
        });
    },
    // [x] checked
    clickOnNavigationLeftArrow: function () {
        trackClick({
            location: "control bar",
            locationDetail: "navigation bar",
            category: "interaction",
            action: "control bar | previous",
        });
    },
    // [x] checked
    clickOnSeeAllPage: function () {
        trackClick({
            location: "control bar",
            locationDetail: "navigation bar",
            category: "interaction",
            action: "see all pages",
        });
    },
    // [x] checked
    clickOnZoomIn: function () {
        trackClick({
            location: "control bar",
            locationDetail: "navigation bar",
            category: "interaction",
            action: "zoom in",
        });
    },
    // [x] checked
    clickOnZoomOut: function () {
        trackClick({
            location: "control bar",
            locationDetail: "navigation bar",
            category: "interaction",
            action: "zoom out",
        });
    },
    // [x] checked
    clickOnActivateFullscreen: function () {
        trackClick({
            location: "control bar",
            locationDetail: "navigation bar",
            category: "interaction",
            action: "activate full screen",
        });
    },
    // [x] checked
    clickOnDectivateFullscreen: function () {
        trackClick({
            location: "control bar",
            locationDetail: "navigation bar",
            category: "interaction",
            action: "deactivate full screen",
        });
    },
    // [NOT USED] from the settlers
    clickOnNavigationDownload: function () {
        trackClick({
            location: "control bar",
            locationDetail: "navigation bar",
            category: "interaction",
            action: "download",
        });
    },
    // [x] checked
    clickOnOpenSongList: function () {
        trackClick({
            location: "control bar",
            locationDetail: "music player",
            category: "interaction",
            action: "song list : open",
        });
    },
    // [x] checked
    songListDisplayed: function () {
        trackImpression({
            location: "control bar",
            locationDetail: "song list",
            category: "display",
            action: "visible",
        });
    },
    // [x] checked
    clickOnPlay: function (musicIndex) {
        var musicTitle = Tracklist[musicIndex].title;
        trackClick({
            location: "control bar",
            locationDetail: "music player",
            category: "audio",
            action: "".concat(musicIndex + 1, " | ").concat(musicTitle, " : play"),
        });
    },
    // [x] checked
    clickOnPause: function (musicIndex) {
        var musicTitle = Tracklist[musicIndex].title;
        trackClick({
            location: "control bar",
            locationDetail: "music player",
            category: "audio",
            action: "".concat(musicIndex + 1, " | ").concat(musicTitle, " : pause"),
        });
    },
    // [x] checked
    clickOnSong: function (musicIndex, currentlyPlaying) {
        var musicTitle = Tracklist[musicIndex].title;
        // Negated condition to be aligned with the tracking plan document order
        if (!currentlyPlaying) {
            trackClick({
                location: "control bar",
                locationDetail: "music player",
                category: "interaction",
                action: "".concat(musicIndex + 1, " | ").concat(musicTitle, " : play"),
            });
        }
        else {
            trackClick({
                location: "control bar",
                locationDetail: "song list",
                category: "audio",
                action: "".concat(musicIndex + 1, " | ").concat(musicTitle, " : play"),
            });
        }
    },
    // [x] checked
    onAutomaticNextSong: function (musicIndex) {
        var musicTitle = Tracklist[musicIndex].title;
        trackClick({
            location: "control bar",
            locationDetail: "music player",
            category: "audio",
            action: "".concat(musicIndex + 1, " | ").concat(musicTitle, " : played"),
        });
    },
    // [x] checked
    clickOnNextSong: function (musicIndex, currentlyPlaying) {
        var musicTitle = Tracklist[musicIndex].title;
        if (currentlyPlaying) {
            trackClick({
                location: "control bar",
                locationDetail: "music player",
                category: "audio",
                action: "".concat(musicIndex + 1, " | ").concat(musicTitle, " : play next"),
            });
        }
        else {
            trackClick({
                location: "control bar",
                locationDetail: "music player",
                category: "interaction",
                action: "".concat(musicIndex + 1, " | ").concat(musicTitle, " : play next"),
            });
        }
    },
    // [x] checked
    clickOnPreviousSong: function (musicIndex, currentlyPlaying) {
        var musicTitle = Tracklist[musicIndex].title;
        if (currentlyPlaying) {
            trackClick({
                location: "control bar",
                locationDetail: "music player",
                category: "audio",
                action: "".concat(musicIndex + 1, " | ").concat(musicTitle, " : play previous"),
            });
        }
        else {
            trackClick({
                location: "control bar",
                locationDetail: "music player",
                category: "interaction",
                action: "".concat(musicIndex + 1, " | ").concat(musicTitle, " : play previous"),
            });
        }
    },
    // [NOT USED] from the settlers
    clickOnAudioSettings: function () {
        trackClick({
            location: "control bar",
            locationDetail: "music player",
            category: "interaction",
            action: "audio settings : open",
        });
    },
    // [x] checked
    // DISABLED
    clickOnMusicAudioSettings: function () {
        // trackClick({
        //   location: "control bar",
        //   locationDetail: "music player",
        //   category: "interaction",
        //   action: "music volume : open",
        // });
    },
    // [x] checked
    // DISABLED
    clickOnSFXAudioSettings: function () {
        // trackClick({
        //   location: "control bar",
        //   locationDetail: "music player",
        //   category: "interaction",
        //   action: "sound effects volume : open",
        // });
    },
    // [x] checked
    onMusicMuted: function () {
        trackClick({
            location: "control bar",
            locationDetail: "music player",
            category: "interaction",
            action: "music volume : mute",
        });
    },
    // [x] checked
    onMusicUnmuted: function () {
        trackClick({
            location: "control bar",
            locationDetail: "music player",
            category: "interaction",
            action: "music volume : unmute",
        });
    },
    // [x] checked
    onSFXMuted: function () {
        trackClick({
            location: "control bar",
            locationDetail: "music player",
            category: "interaction",
            action: "sound effects volume : mute",
        });
    },
    // [x] checked
    onSFXUnmuted: function () {
        trackClick({
            location: "control bar",
            locationDetail: "music player",
            category: "interaction",
            action: "sound effects volume : unmute",
        });
    },
    // [x] checked
    clickOnDownloadMasterBar: function () {
        trackClick({
            location: "master bar",
            locationDetail: "profile bar",
            category: "interaction",
            action: "download : open",
        });
    },
    // [x] checked
    clickOnOpenTutorial: function () {
        trackClick({
            location: "master bar",
            locationDetail: "profile bar",
            category: "interaction",
            action: "tutorial : open",
        });
    },
    // REMOVED
    clickOnPlayerIcon: function () {
        trackClick({
            location: "master bar",
            locationDetail: "profile bar",
            category: "interaction",
            action: "profile : open",
        });
    },
    // REMOVED
    clickOnGamePageCTA: function () {
        trackClick({
            location: "master bar",
            locationDetail: "profile bar",
            category: "action",
            action: "".concat(getInstallmentName(), " : learn more"),
        });
    },
    // [x] checked
    clickOnLogoutMasterBar: function () {
        trackClick({
            location: "master bar",
            locationDetail: "profile bar",
            category: "interaction",
            action: "logout",
        });
    },
    // [x] checked
    onMainTutorialDisplayed: function () {
        trackPage({
            pageName: "main",
            pageUrl: window.location.href,
            siteSection: "tutorial",
        });
        trackImpression({
            location: "tutorial",
            category: "display",
            locationPosition: "pop in",
            action: "visible",
        });
    },
    onReminderTutorialDisplayed: function () {
        trackImpression({
            location: "tutorial",
            category: "display",
            locationPosition: "pop in",
            action: "visible",
        });
    },
    // [x] checked
    clickOnEnter: function () {
        trackClick({
            location: "tutorial",
            category: "interaction",
            locationPosition: "pop in",
            action: "enter",
        });
    },
    // [x] checked
    // DISABLED
    clickOnLanguageSelector: function () {
        // trackClick({
        //   location: "tutorial",
        //   locationDetail: "language selector",
        //   category: "interaction",
        //   locationPosition: "pop in",
        //   action: "language selector : open",
        // });
    },
    // [x] checked
    onLanguageSelected: function (language) {
        trackClick({
            location: "tutorial",
            locationDetail: "language selector",
            category: "interaction",
            locationPosition: "pop in",
            action: "".concat(language.toLowerCase(), " : select"),
        });
    },
    // [NOT USED] from the settlers
    onLanguageSelectedHeader: function (language) {
        trackClick({
            location: "header",
            locationDetail: "language selector",
            category: "interaction",
            locationPosition: "pop in",
            action: "".concat(language.toLowerCase(), " : select"),
        });
    },
    // [x] checked
    onDownloadPopinDisplayed: function () {
        trackImpression({
            location: "download",
            category: "display",
            locationPosition: "pop in",
            action: "visible",
        });
    },
    // [x] checked
    clickOnDownloadSoundtrack: function () {
        trackClick({
            location: "download",
            category: "download",
            locationPosition: "pop in",
            action: "soundtrack : download content",
        });
    },
    // [x] checked
    clickOnDownloadArtbook: function (definition, language) {
        trackClick({
            location: "download",
            category: "download",
            locationPosition: "pop in",
            action: "artbook | ".concat(definition || "hd", " | ").concat(language.toLowerCase(), " : download content"),
        });
    },
    // not in this version
    clickOnDownloadLanguageSelector: function () {
        trackClick({
            location: "download",
            category: "interaction",
            locationPosition: "pop in",
            action: "language selector : open",
        });
    },
    // not in this version
    clickOnDownloadLanguageSelected: function (language) {
        trackClick({
            location: "download",
            category: "interaction",
            locationPosition: "pop in",
            action: "".concat(language, " : select"),
        });
    },
    // [x] checked
    clickOnCloseDownloadPopin: function () {
        trackClick({
            location: "download",
            category: "interaction",
            locationPosition: "pop in",
            action: "close pop in",
        });
    },
    onPreviewVisible: function () {
        trackImpression({
            location: "control bar",
            locationDetail: "pages bar",
            category: "display",
            action: "visible",
        });
    },
    clickOnPreviewNext: function () {
        trackClick({
            location: "control bar",
            locationDetail: "pages bar",
            category: "display",
            action: "next",
        });
    },
    clickOnPreviewPrevious: function () {
        trackClick({
            location: "control bar",
            locationDetail: "pages bar",
            category: "display",
            action: "previous",
        });
    },
    clickOnPreviewThumbnail: function (pageIndex) {
        trackClick({
            location: "control bar",
            locationDetail: "pages bar",
            category: "interaction",
            action: "page ".concat((pageIndex + 1) * 2),
        });
    },
};
